import moment from 'moment';
import { tify, sify } from 'chinese-conv';
import { alertWindow } from './screenActions';

/**
 *
 * @param {"gateway"|"light"|"daliCtl"|"sensor"|"server"|"zoneControl"} deviceType
 * @param {"dark"|"light"} colorScheme
 * @returns
 */
export const deviceColor = (deviceType, colorScheme) => {
  if (deviceType === 'gateway' && colorScheme === 'dark') return '#b03a2e';
  if (deviceType === 'gateway' && colorScheme === 'light') return '#f1948a';
  if (deviceType === 'light' && colorScheme === 'dark') return '#b7950b';
  if (deviceType === 'light' && colorScheme === 'light') return '#f7dc6f';
  if (deviceType === 'daliCtl' && colorScheme === 'dark') return '#76448a';
  if (deviceType === 'daliCtl' && colorScheme === 'light') return '#c39bd3';
  if (deviceType === 'sensor' && colorScheme === 'dark') return '#117a65';
  if (deviceType === 'sensor' && colorScheme === 'light') return '#73c6b6';
  if (deviceType === 'server' && colorScheme === 'dark') return '#616a6b';
  if (deviceType === 'server' && colorScheme === 'light') return '#bfc9ca';
  if (deviceType === 'zoneControl' && colorScheme === 'dark') return '#1f618d';
  if (deviceType === 'zoneControl' && colorScheme === 'light') return '#85c1e9';
  if (deviceType === 'modbusSlave' && colorScheme === 'dark') return '#205781';
  if (deviceType === 'modbusSlave' && colorScheme === 'light') return '#98d2c0';
};

export const printPdf = (mainTitle, subTitle, printBody, disableMainTitle, disableSubTitle, classStyles) => {
  var mywindow = window.open('', 'Print', 'height=600,width=800');
  mywindow.document.write(`<html><head><title>${mainTitle}-${subTitle}</title>`);
  mywindow.document.write('<style>');
  mywindow.document.write('table {margin:auto;width:100%;boarder: 1px solid grey;border-collapse:collapse}');
  mywindow.document.write('td,th {border: 1px solid grey;border-collapse: collapse;font-size:0.8em}');
  mywindow.document.write('.noPrint {display:none;}');
  mywindow.document.write('.blue {color:blue;}');
  mywindow.document.write('</style>');
  mywindow.document.write('</head><body>');
  if (!disableMainTitle) {
    mywindow.document.write(`<h3>${mainTitle}</h3>`);
  }
  if (!disableSubTitle) {
    mywindow.document.write(`<h4>${subTitle}</h4>`);
  }
  mywindow.document.write(`<hr />`);
  mywindow.document.write(printBody);
  mywindow.document.write('</body></html>');
  mywindow.document.close();
  mywindow.focus();
  mywindow.print();
  mywindow.close();
  return true;
};
export const lightColorAt = (disabledStatus, statusL, lightLv) => {
  if (disabledStatus || lightLv === undefined || lightLv === null) return 'transparent';
  if (statusL === 1) return '#FFF599';
  if (lightLv === 0) return '#b2babb';
  // lightColor = "#FFE600";
  return hexColorFromLightLevel(lightLv);
};
function interpolateColor(color1, color2, factor) {
  if (arguments.length < 3) {
    factor = 0.5;
  }
  const result = color1.slice();
  for (let i = 0; i < 3; i++) {
    result[i] = Math.round(result[i] + factor * (color2[i] - result[i]));
  }
  return result;
}

function hexColorFromLightLevel(lightLevel) {
  const white = [255, 255, 255]; // RGB for white
  const targetColor = [255, 230, 0]; // RGB for #FFE600

  // Ensure lightLevel is within 0-100
  lightLevel = Math.max(0, Math.min(100, lightLevel));

  // Calculate interpolation factor
  const factor = lightLevel / 100;

  // Interpolate between white and targetColor
  const interpolatedColor = interpolateColor(white, targetColor, factor);

  // Convert RGB to hex
  const hexColor = interpolatedColor.map(c => c.toString(16).padStart(2, '0')).join('');

  return `#${hexColor}`;
}
export const sensorStringsOfType = (type, status, status2, status3, status4) => {
  let sensorTypeName, statusTerm;
  switch (type) {
    case 'motion': {
      sensorTypeName = 'Motion sensor';
      statusTerm = status ? 'Motion detected' : 'No motion detected';
      break;
    }
    case 'daylight': {
      sensorTypeName = 'Daylight Sensor';
      statusTerm = `lux level ${status}`;
      break;
    }
    case 'lightswitch': {
      sensorTypeName = 'Light switch';
      statusTerm = status ? 'Switch On' : 'Switch Off';
      break;
    }
    case 'daylightmotion': {
      sensorTypeName = 'Daylight Motion Sensor';
      statusTerm = 'lux level';
      break;
    }
    case 'scenebutton': {
      sensorTypeName = 'Scene button';
      statusTerm = status
        ? 'Button1 pressed'
        : status2
          ? 'Button2 pressed'
          : status3
            ? 'Button3 pressed'
            : status4
              ? 'Button4 pressed'
              : '';
      break;
    }

    case 'dimcontroller': {
      sensorTypeName = 'Dimmer Controller';
      statusTerm = status ? 'Up' : status2 ? 'Down' : '';
      break;
    }
    case 'fire': {
      sensorTypeName = 'General fire alarm';
      statusTerm = status ? 'Fire Alarm' : 'Normal';
      break;
    }
    case 'breakglass': {
      sensorTypeName = 'Fire breakglass unit';
      statusTerm = status ? 'Alarm' : 'Normal';
      break;
    }
    case 'smoke': {
      sensorTypeName = 'Smoke detector';
      statusTerm = status ? 'Alarm' : 'Normal';
      break;
    }
    case 'nursecall': {
      sensorTypeName = 'Nurse call button';
      statusTerm = status ? 'Call' : 'Normal';
      break;
    }
    default: {
      sensorTypeName = 'Unknown sensor';
      statusTerm = status ? 'Sensor On' : 'Sensor Off';
    }
  }
  return { sensorTypeName, statusTerm };
};
export function getDaysInMonth(month, year) {
  return new Date(year, month, 0).getDate();
}
export function getSchBoxColorText(reportType) {
  let backgroundColor, tooltipText;
  switch (reportType) {
    case 'check_6month': {
      backgroundColor = '#ffb3d9';
      tooltipText = '6-month test';
      break;
    }
    case 'check_12month': {
      backgroundColor = '#ff6600';
      tooltipText = 'Annual test';
      break;
    }
    case 'check_36month': {
      backgroundColor = '#ff3300';
      tooltipText = '3-year test';
      break;
    }
    default: {
      backgroundColor = '#669999';
      tooltipText = 'Monthly test';
    }
  }
  return { backgroundColor, tooltipText };
}
export const getConnectStatusOf = lightObj => {
  const { zigbeeConnected, timeStamp, comm } = lightObj || {};
  let status = 'disconnected';
  const latestDataTimeFromNow = moment().diff(moment(timeStamp), 'minutes');
  if (latestDataTimeFromNow > 15 && timeStamp) {
    status = 'timeout';
  } else if ((zigbeeConnected || comm === 'wifi' || latestDataTimeFromNow < 10) && timeStamp) {
    status = 'connected';
  }
  return status;
};

// export const lineColor = (no) => {
//   const arr = [
//     "#7D3C98",
//     "#E74C3C",
//     "#28B463",
//     "#76D7C4",
//     "#AAB7B8",
//     "#F7DC6F",
//     "#BB8FCE",
//     "#E59866",
//     "#AAB7B8",
//     "#AAB7B8",
//     "#CD6155",
//     "#1ABC9C",
//     "#34495E",
//     "#8E44AD",
//     "#CB4335",
//     "#85C1E9",
//     "#76D7C4",
//     "#BB8FCE",
//     "#F7DC6F",
//     "#E59866",
//     "#AAB7B8",
//     "#CD6155",
//     "#1ABC9C",
//     "#34495E",
//     "#8E44AD",
//     "#CB4335",
//   ];
//   return arr[no];
// };
// export const getConnectStatus = (tsp) => {
//   const m = moment(tsp);
//   if (tsp === 0 || !tsp) {
//     return false;
//   }
//   if (moment().diff(m, "minutes") < 10) {
//     return true;
//   } else {
//     return false;
//   }
// };

// export function getZoneControlIconArray() {
//   return [
//     "finger",
//     "greenPwr",
//     "redPwr",
//     "greenPwrSq",
//     "redPwrSq",
//     "bluePwr",
//     "orangePwr",
//     "clock",
//     "dimColor",
//     "dimOrange",
//   ];
// }
export const secToMin = secNum => {
  if (!secNum) return '0s';
  let dur = moment.duration(secNum, 'seconds');
  if (secNum < 60) {
    return `${secNum}s`;
  } else if (secNum >= 60 && secNum < 3600) {
    const min = dur.minutes();
    const sec = secNum % 60;
    let output = `${min}min `;
    if (sec > 0) output += `${sec}s`;
    return output;
  } else {
    const h = dur.hours();
    const min = dur.minutes();
    const sec = dur.seconds();
    let output = `${h}h `;
    if (min > 0 || sec > 0) output += `${min}min `;
    if (sec > 0) output += `${sec}s`;
    return output;
  }
};
export const darkColorArr = ['#1A5276', '#B9770E', '#B03A2E', '#515A5A', '#0E6655', '#5B2C6F'];
export const tspToDateTime = (tsp, hideSecond) => {
  if (!tsp) return '-';
  if (hideSecond) {
    return moment(tsp).format('YYYY-MM-DD HH:mm');
  } else {
    return moment(tsp).format('YYYY-MM-DD HH:mm:ss');
  }
};
export const deviceConnected = (zigbeeConnected, timeStamp, gatewayConnected) => {
  if (!timeStamp) return false;
  if (!gatewayConnected) {
    return false;
  } else if (zigbeeConnected && moment().diff(moment(timeStamp), 'minutes') < 10) {
    return true;
  } else {
    return false;
  }
};
export const isConnected = (deviceObj, state) => {
  const { gatewayID } = deviceObj || {};
  if (!deviceObj) return false;
  let gatewayConnected = false;
  if (deviceObj.masterLmcID) gatewayConnected = state.lmcObjAll[deviceObj.masterLmcID]?.gatewayConnected;
  else gatewayConnected = state.gatewayObjAll[gatewayID]?.gatewayConnected;
  return deviceConnected(deviceObj.zigbeeConnected, deviceObj.timeStamp, gatewayConnected);
};
export const gatewayConnected = gatewayObj => {
  if (!gatewayObj) {
    return false;
  } else if (
    gatewayObj.gatewayConnected
    // && moment().diff(moment(gatewayObj.gatewayAliveTimeStamp), "minutes") < 10
  ) {
    return true;
  } else {
    return false;
  }
};
export async function fetchWithTimeout(resource, options = {}) {
  const { timeout = 8000 } = options;

  const controller = new AbortController();
  const id = setTimeout(() => controller.abort(), timeout);

  const response = await fetch(resource, {
    ...options,
    signal: controller.signal,
  });
  clearTimeout(id);

  return response;
}
export const isMatch = (s1, s2) => {
  if (!s1 || !s2) return false;
  return (
    s1?.toString().toUpperCase()?.includes(s2?.toUpperCase()?.toString()) ||
    s1?.toString().toLowerCase()?.includes(s2?.toLowerCase()?.toString()) ||
    s1?.includes(tify(s2 || '')) ||
    s1?.includes(sify(s2) || '') ||
    s1 === s2
  );
};
export const meshFreqMap = {
  [0b00]: '430-446MHz [0]',
  [0b01]: '454-469MHz [1]',
  [0b10]: '470-486MHz [2]',
  [0b11]: '494-509MHz [3]',
  [99]: '-',
};
export const meshSpeedMap = {
  0: '62.5 [0]',
  0x10: '37.5 [10]',
  0x20: '21.8 [20]',
  0x30: '12.5 [30]',
  0x40: '7 [40]',
  0x50: '3.9 [50]',
  0x60: '2.1 [60]',
  99: '-',
};
export const meshPowerDbmMap = {
  0: '22 [0]',
  1: '20 [1]',
  2: '17 [2]',
  3: '14 [3]',
  4: '11 [4]',
  5: '8 [5]',
  6: '5 [6]',
  7: '2 [7]',
  99: '-',
};
export const meshBaudrateMap = {
  0: '2400 [0]',
  1: '4800 [1]',
  2: '9600 [2]',
  3: '14400 [3]',
  4: '19200 [4]',
  5: '38400 [5]',
  6: '57600 [6]',
  7: '115200 [7]',
  99: '-',
};
export const meshChannelMap = {
  0: '0',
  1: '1',
  2: '2',
  3: '3',
  4: '4',
  5: '5',
  6: '6',
  7: '7',
  8: '8',
  9: '9',
  10: '10',
  11: '11',
  12: '12',
  13: '13',
  14: '14',
  15: '15',
  16: '16',
  17: '17',
  18: '18',
  19: '19',
  20: '20',
  21: '21',
  22: '22',
  23: '23',
  24: '24',
  25: '25',
  26: '26',
  27: '27',
  28: '28',
  29: '29',
  30: '30',
  31: '31',
  99: '-',
};

export const deviceInfoOfObj = (deviceObj, inputDeviceType) => {
  let deviceID = '';
  let deviceType = inputDeviceType || '';
  let deviceNameField = '';
  let deviceName = '';
  let deviceStyle = '';
  let deviceIDField = '';
  let deviceMgCol = '';
  let deviceFsCol = '';
  if (deviceObj?.serial || inputDeviceType === 'light') {
    deviceID = deviceObj?.serial;
    deviceType = 'light';
    deviceNameField = 'description';
    deviceName = deviceObj?.[deviceNameField];
    deviceStyle = deviceObj?.style;
    deviceIDField = 'serial';
    deviceMgCol = 'serial';
    deviceFsCol = 'SM_serial';
  } else if (deviceObj?.sensorID || inputDeviceType === 'sensor') {
    deviceID = deviceObj?.sensorID;
    deviceType = 'sensor';
    deviceNameField = 'sensorName';
    deviceName = deviceObj?.[deviceNameField];
    deviceStyle = deviceObj?.type;
    deviceIDField = 'sensorID';
    deviceMgCol = 'sensor';
    deviceFsCol = 'SM_sensor';
  } else if ((deviceObj?.zoneControlID && !deviceObj?.hour) || inputDeviceType === 'zoneControl') {
    deviceID = deviceObj?.zoneControlID;
    deviceType = 'zoneControl';
    deviceNameField = 'zoneControlName';
    deviceName = deviceObj?.[deviceNameField];
    deviceStyle = deviceObj?.type;
    deviceIDField = 'zoneControlID';
    deviceMgCol = 'zoneControl';
    deviceFsCol = 'SM_zoneControl';
  } else if (
    (deviceObj?.gatewayID && (deviceObj?.localserverUrl || deviceObj?.gwVersion || deviceObj?.ttyS7)) ||
    inputDeviceType === 'gateway'
  ) {
    deviceID = deviceObj?.gatewayID;
    deviceType = 'gateway';
    deviceNameField = 'description';
    deviceName = deviceObj?.[deviceNameField];
    deviceIDField = 'gatewayID';
    deviceMgCol = 'gateway';
    deviceFsCol = 'SM_gateway';
  } else if ((deviceObj?.daliCtlID && deviceObj?.daliType) || inputDeviceType === 'daliCtl') {
    deviceID = deviceObj?.daliCtlID;
    deviceType = 'daliCtl';
    deviceNameField = 'description';
    deviceName = deviceObj?.[deviceNameField];
    deviceIDField = 'daliCtlID';
    deviceMgCol = 'daliCtl';
    deviceFsCol = 'SM_daliCtl';
  } else if ((deviceObj?.lmcID && !deviceObj?.serial) || inputDeviceType === 'lmc') {
    deviceID = deviceObj?.lmcID;
    deviceType = 'lmc';
    deviceNameField = 'description';
    deviceName = deviceObj?.[deviceNameField];
    deviceIDField = 'lmcID';
    deviceMgCol = 'lmc';
    deviceFsCol = 'SM_lmc';
  } else if ((deviceObj?.markID && deviceObj?.markType) || inputDeviceType === 'mark') {
    deviceID = deviceObj?.markID;
    deviceType = 'mark';
    deviceNameField = 'title';
    deviceName = deviceObj?.[deviceNameField];
    deviceIDField = 'markID';
    deviceMgCol = 'mark';
    deviceFsCol = 'SM_mark';
  } else if ((deviceObj?.timeTableID && deviceObj?.hour) || inputDeviceType === 'timeTable') {
    deviceID = deviceObj?.timeTableID;
    deviceType = 'timeTable';
    deviceNameField = '-';
    deviceName = '-';
    deviceIDField = 'timeTableID';
    deviceMgCol = 'timeTable';
    deviceFsCol = 'SM_timeTable';
  } else if ((deviceObj?.mapID && deviceObj?.mapFileName) || inputDeviceType === 'map') {
    deviceID = deviceObj?.mapID;
    deviceType = 'map';
    deviceNameField = 'mapName';
    deviceName = deviceObj?.[deviceNameField];
    deviceIDField = 'mapID';
    deviceMgCol = 'map';
    deviceFsCol = 'SM_map';
  } else if ((deviceObj?.serverID && deviceObj?.serVersion) || inputDeviceType === 'server') {
    deviceID = deviceObj?.serverID;
    deviceType = 'server';
    deviceNameField = 'description';
    deviceName = deviceObj?.[deviceNameField];
    deviceIDField = 'serverID';
    deviceMgCol = 'server';
    deviceFsCol = 'SM_server';
  } else if (deviceObj?.modbusSlaveID || inputDeviceType === 'modbusSlave') {
    deviceID = deviceObj?.modbusSlaveID;
    deviceType = 'modbusSlave';
    deviceNameField = 'description';
    deviceName = deviceObj?.[deviceNameField];
    deviceIDField = 'modbusSlaveID';
    deviceMgCol = 'modbusSlave';
    deviceFsCol = 'SM_modbusSlave';
  } else if (deviceObj?.adfDeviceID || inputDeviceType === 'adfDevice') {
    deviceID = deviceObj?.adfDeviceID;
    deviceType = 'adfDevice';
    deviceNameField = 'adfName';
    deviceName = deviceObj?.[deviceNameField];
    deviceIDField = 'adfDeviceID';
    deviceMgCol = 'adfDevice';
    deviceFsCol = 'SM_adfDevice';
  } else {
    deviceID = 'unknown';
    deviceType = 'unknown';
    deviceNameField = 'unknown';
    deviceName = 'unknown';
    deviceStyle = 'unknown';
    deviceIDField = 'unknown';
    deviceMgCol = 'unknown';
    deviceFsCol = 'unknown';
  }
  return {
    deviceID,
    deviceType,
    deviceName,
    deviceStyle,
    deviceIDField,
    deviceMgCol,
    deviceFsCol,
    deviceNameField,
  };
};
export const deviceTypeName = (type, firstCharUpper = false, gang) => {
  let name = '';
  switch (type) {
    case "light":
    case "serial":
      name = 'light';
      break;
    case "sensor":
      name = 'sensor';
      break;
    case "zoneControl":
      name = 'zone control';
      break;
    case 'motion':
      name = 'motion sensor';
      break;
    case 'daylight':
      name = 'daylight harvest sensor';
      break;
    case 'daylightmotion':
      name = 'daylight motion sensor';
      break;
    case 'scenebutton': {
      name = 'scene button';
      if (gang) name += ` ${gang}gang`;
      break;
    }
    case 'lightswitch': {
      name = 'light switch';
      if (gang) name += ` ${gang}gang`;
      break;
    }
    case 'dimcontroller':
      name = 'dim controller';
      break;
    case 'timer':
      name = 'timer';
      break;
    case 'zcSceneButton':
      name = 'virtual scene button';
      break;
    case 'zcSwitch':
      name = 'virtual switch';
      break;
    case 'dimming':
      name = 'group dimming';
      break;
    case 'daliCtl':
      name = 'Dali controller';
      break;
    case 'gateway':
      name = 'gateway';
      break;
    case 'server':
      name = 'server';
      break;
    default:
      name = 'unknown';
  }
  if (firstCharUpper) name = name.charAt(0).toUpperCase() + name.slice(1);
  return name;
};
export const alertIfDisconnected = (deviceObj, state, dispatch) => {
  const { gatewayObjAll } = state;
  const deviceInfo = deviceInfoOfObj(deviceObj);
  let disconnected;
  if (deviceInfo.deviceType === 'gateway') {
    disconnected = !gatewayConnected(deviceObj);
  } else {
    const gatewayConnected = gatewayObjAll[deviceObj.gatewayID]?.gatewayConnected;
    disconnected = !deviceConnected(deviceObj.zigbeeConnected, deviceObj.timeStamp, gatewayConnected);
  }
  if (disconnected) {
    alertWindow(dispatch, 'Device is disconnected');
    return true;
  } else {
    return false;
  }
};
export const deviceInterfaceTypeOf = deviceObj => {
  if (!deviceObj) return 'unknown';
  else if (deviceObj.zigbeeAdd) return 'zigbee';
  else if (deviceObj.dtkAdd) {
    if (deviceObj.dtkChannel === undefined && Number(deviceObj.meshChannel >= 0)) return 'mesh255';
    else if (Number(deviceObj.dtkChannel) >= 0) return 'DTK';
    else return 'DTK or mesh255';
  } else {
    return 'unknownType';
  }
};
export const sensorHeadTypeNameOf = code => {
  switch (code) {
    case 0:
      return 'multi-functional sensor head';
    case 1:
      return 'pcf touch panel';
    case 2:
      return 'esp touch panel';
    default:
      return 'unknown';
  }
};
export const settingNumArrayOf = (type, gang = 1) => {
  switch (type) {
    case 'motion':
    case 'zcSceneButton':
      return [1];
    case 'timer':
    case 'zcSwitch':
      return [1, 2];
    case 'scenebutton':
    case 'dimcontroller':
      let arr1 = [];
      for (let i = 1; i <= gang; i++) {
        arr1.push(i);
      }
      return arr1;
    case 'lightswitch':
      let arr2 = [];
      for (let i = 1; i <= gang * 2; i++) {
        arr2.push(i);
      }
      return arr2;
    case 'daylight':
      return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
    default:
      return [1];
  }
};
export const confirmAllGroupAction = (groupDeviceObj, settingNumArray) => {
  let allConfirmed = 'success';
  let allSetQty = 0;
  settingNumArray.forEach(settingNum => {
    const set = groupDeviceObj?.[`setting${settingNum}`] || {};
    allSetQty += Object.keys(set).length;
    const GAS_set = groupDeviceObj?.[`GAS_setting${settingNum}`];
    if (GAS_set) {
      Object.keys(set).forEach(s => {
        const daliCtlID = set[s]?.daliCtlID;
        if (daliCtlID) {
          const confirmed = GAS_set[daliCtlID]?.confirmed || false;
          if (!confirmed) allConfirmed = 'error';
        } else {
          const confirmed = GAS_set[s]?.confirmed || false;
          if (!confirmed) allConfirmed = 'error';
        }
      });
    }
  });
  if (allSetQty === 0) allConfirmed = 'disabled';
  return allConfirmed;
};
export const toUpdateVer = (curVer, newVer) => {
  if (!curVer || !newVer) return false;
  const curVerArr = curVer.split('.').map(e => Number(e));
  const newVerArr = newVer.split('.').map(e => Number(e));
  if (newVerArr[0] > curVerArr[0]) {
    return true;
  } else if (newVerArr[0] === curVerArr[0] && newVerArr[1] > curVerArr[1]) {
    return true;
  } else if (newVerArr[0] === curVerArr[0] && newVerArr[1] === curVerArr[1] && newVerArr[2] > curVerArr[2]) {
    return true;
  } else {
    return false;
  }
};
export const removeDuplicates = array => {
  const seen = new Set();
  return (array || []).filter(item => {
    if (seen.has(item)) {
      return false; // Duplicate found, do not include in the new array
    }
    seen.add(item);
    return true; // Unique item, include in the new array
  });
};
export const macArrayToHexStr = macArray => {
  if (!macArray) return '';
  return macArray.map(byte => byte.toString(16).padStart(2, '0')).join('');
};
export const macHexStringToArray = macStr => {
  if (!macStr) return [];
  return macStr.match(/.{1,2}/g).map(byte => parseInt(byte, 16));
};
export const timeTableInfoOf = timeTableObj => {
  const { timeTableID, minute, hour, date, month, year, cron, excludeHoliday, onlyHoliday, isoWeekday, oneTime } =
    timeTableObj || {};
  let obj = { ...timeTableObj };
  obj.hhmm = `${hour?.[0]?.toString().padStart(2, '0')}:${minute?.[0]?.toString().padStart(2, '0')}`;
  const weekDayStrArray = (isoWeekday || []).map(d => {
    if (d === 1) return 'Mon';
    else if (d === 2) return 'Tue';
    else if (d === 3) return 'Wed';
    else if (d === 4) return 'Thu';
    else if (d === 5) return 'Fri';
    else if (d === 6) return 'Sat';
    else return 'Sun';
  });
  obj.weekDayStrArray = weekDayStrArray;
  obj.weekMessage = `Every ${(weekDayStrArray || []).join(', ')} ${excludeHoliday ? 'Exclude holiday' : ''} ${onlyHoliday ? 'Only holiday' : ''}`;
  obj.oneTimeStr = oneTime ? `${moment().month((month?.[0] || 1) - 1).date(date?.[0] || 1).hour(hour?.[0] || 0).minute(minute?.[0] || 0).format("DD-MMM, HH:mm")}` : "";
  return obj;
};
export const mergeArray = (arr1, arr2) => {
  return [...new Set([...(arr1 || []), ...(arr2 || [])])];
};
/**
 *
 * @param {*} arr1
 * @param {*} arr2
 * @returns {boolean} true if arr1 has duplicates in arr2, false otherwise
 */
export const arraysHaveDuplicates = (arr1, arr2) => {
  return arr1.some(item => arr2.includes(item));
};

/**
 * Converts a hex color string to an RGB string.
 *
 * @param {string} hexColor - The hex color string in the format "#RRGGBB".
 * @returns {string} The RGB color string in the format "r, g, b".
 */
export const hexColorToRgba = hexColor => {
  if (hexColor.startsWith('#')) hexColor = hexColor.slice(1);
  const r = parseInt(hexColor.slice(0, 2), 16);
  const g = parseInt(hexColor.slice(2, 4), 16);
  const b = parseInt(hexColor.slice(4, 6), 16);
  return `${r}, ${g}, ${b}`;
};

/**
 * Converts an RGB string to a hex color string.
 *
 * @param {string} rgbaColor - The RGB color string in the format "r, g, b".
 * @returns {string} The hex color string in the format "#RRGGBB".
 */
export const rgbaToHexColor = rgbaColor => {
  if (!rgbaColor) return '';
  const [r, g, b] = rgbaColor.split(',').map(e => Number(e));
  if (r === undefined || g === undefined || b === undefined) return '';
  return `#${r.toString(16).padStart(2, '0')}${g.toString(16).padStart(2, '0')}${b.toString(16).padStart(2, '0')}`;
};

export const isRgbaColor = color => {
  return color.startsWith('rgba') || color.includes(',');
};

export const isHexColor = color => {
  return color.startsWith('#') && !color.includes(',');
};

export const pointArrayToSvgPath = (pointArray, mapScale) => {
  if (pointArray.length === 0) return '';
  const startPoint = pointArray[0];
  const pathData = pointArray.map(point => `L${point.x * mapScale.x},${point.y * mapScale.y}`).join(' ');
  return `M${startPoint.x * mapScale.x},${startPoint.y * mapScale.y} ${pathData} Z`;
};
export const cursorOnLayer = layerProps => {
  const { enableZoom, enablePan, mapLayer, zonePlanningObj } = layerProps;
  if (mapLayer.realDimension || zonePlanningObj?.isDrawingZonepolygon) return 'crosshair';
  else if (enableZoom === 'in') return 'zoom-in';
  else if (enableZoom === 'out') return 'zoom-out';
  else if (enablePan) return 'grab';
  else return 'default';
};
export const convertToNumber = value => {
  if (value === true || value === 'true' || value === '1') return 1;
  if (
    value === false ||
    value === 'false' ||
    value === '0' ||
    value === undefined ||
    value === 'null' ||
    value === 'undefined'
  )
    return 0;
  return Number(value);
};
export const isValidMeshChannel = meshChannel => {
  const isValidMeshChannel =
    typeof meshChannel === 'number' && !isNaN(meshChannel) && meshChannel >= 0 && meshChannel <= 31;
  return isValidMeshChannel;
};
export const isValidDtkChannel = dtkChannel => {
  const isValidDtkChannel =
    typeof dtkChannel === 'number' && !isNaN(dtkChannel) && dtkChannel >= 20 && dtkChannel <= 70;
  return isValidDtkChannel;
};
export const dtkTypeOf = (code) => {
  if (Number(code) === 0) return "-";
  else if (Number(code) === 1) return "coordinator";
  else if (Number(code) === 2) return "router";
  else if (Number(code) === 3) return "endpoint";
  else return "unknown";
};
/**
 * 计算周围物品的位置数组
 * @param {Object} centerPos - 中心物品位置 {x, y}
 * @param {number} surroundingCount - 周围物品数量
 * @param {number} radius - 半径（可选，默认为50）
 * @param {number} startAngle - 起始角度（可选，默认为0度）
 * @returns {Array} 周围物品位置数组 [{x, y}, {x, y}, ...]
 */
export const calculateSurroundingPositions = (centerPos, surroundingCount, radius = 50, startAngle = 0) => {
  if (!centerPos || typeof centerPos.x !== 'number' || typeof centerPos.y !== 'number') {
    throw new Error('中心位置必须是包含x和y数字属性的对象');
  }

  if (surroundingCount <= 0) {
    return [];
  }

  if (surroundingCount === 1) {
    // 只有一个物品时，放在中心点右侧
    return [
      {
        x: centerPos.x + radius,
        y: centerPos.y,
      },
    ];
  }

  const positions = [];
  const angleStep = (2 * Math.PI) / surroundingCount; // 平均分配角度

  for (let i = 0; i < surroundingCount; i++) {
    const angle = startAngle + i * angleStep;
    const x = centerPos.x + radius * Math.cos(angle);
    const y = centerPos.y + radius * Math.sin(angle);

    positions.push({
      x: Math.round(x * 100) / 100, // 保留两位小数
      y: Math.round(y * 100) / 100,
    });
  }

  return positions;
};

/**
 * 计算网格布局的周围物品位置
 * @param {Object} centerPos - 中心物品位置 {x, y}
 * @param {number} surroundingCount - 周围物品数量
 * @param {number} gridSize - 网格大小（可选，默认为60）
 * @returns {Array} 周围物品位置数组 [{x, y}, {x, y}, ...]
 */
export const calculateGridSurroundingPositions = (centerPos, surroundingCount, gridSize = 60) => {
  if (!centerPos || typeof centerPos.x !== 'number' || typeof centerPos.y !== 'number') {
    throw new Error('中心位置必须是包含x和y数字属性的对象');
  }

  if (surroundingCount <= 0) {
    return [];
  }

  const positions = [];
  const maxItemsPerRow = Math.ceil(Math.sqrt(surroundingCount));
  const maxItemsPerCol = Math.ceil(surroundingCount / maxItemsPerRow);

  let itemIndex = 0;
  for (let row = 0; row < maxItemsPerCol && itemIndex < surroundingCount; row++) {
    for (let col = 0; col < maxItemsPerRow && itemIndex < surroundingCount; col++) {
      const x = centerPos.x + (col - Math.floor(maxItemsPerRow / 2)) * gridSize;
      const y = centerPos.y + (row - Math.floor(maxItemsPerCol / 2)) * gridSize;

      // 跳过中心位置
      if (Math.abs(x - centerPos.x) < 1 && Math.abs(y - centerPos.y) < 1) {
        continue;
      }

      positions.push({ x, y });
      itemIndex++;
    }
  }

  return positions;
};
export const newArrayBetween = (start, end) => {
  if (end < start) return [];
  if (end === start) return [start];
  if (end === 0) return [];
  return Array.from({ length: end - start + 1 }, (_, i) => start + i);
};
export const isEmptyJson = obj => {
  return Object.keys(obj || {}).length === 0;
};
export const waitFor = ms => {
  return new Promise(resolve => setTimeout(resolve, ms));
};
export const arraySameItem = arr => {
  if (arr.every(item => item === arr[0])) return arr[0];
  else return false;
};
export const asyncForEach = async (arr, callback) => {
  for (let i = 0; i < arr.length; i++) {
    await callback(arr[i], i, arr);
  }
};
export const arrayIsIdentical = (arr1, arr2) => {
  if (arr1.length !== arr2.length) return false;
  for (let i = 0; i < arr1.length; i++) {
    if (arr1[i] !== arr2[i]) return false;
  }
  return true;
};
